<script setup lang="ts">
import { useCategoryStore } from '~~/stores/category'
defineOptions({
  name: 'KategoriWrapper'
})
const { isMobile } = useDevice()

const categoryStore = useCategoryStore()
categoryStore.fetchCategories({ size: 100 })
</script>

<template>
  <a-row :gutter="[40, 40]">
    <a-col v-if="!isMobile" :md="7" :sm="24" :xs="24">
      <LazyModulesKategoriMoleculesAside />
    </a-col>
    <a-col :md="17" :sm="24" :xs="24">
      <LazyModulesKategoriMoleculesContent />
    </a-col>
  </a-row>
</template>

<style lang="scss">
@use './styles.scss';
</style>
